import Tooltip from 'bootstrap.native/dist/components/tooltip-native.esm.js'

export function productQtyForm() {
    const qtyForm = document.querySelectorAll('.qty-form'),
        submit = document.querySelector('.btn-update[name=update_cart_action]'),
        maxQtyTooltip = document.getElementById('max-qty-tooltip'),
        activeTooltips = {}

    const showQtyTooltip = (id) => {
        const tooltipId = id || 'only-one'
        if (!activeTooltips[tooltipId]) {
            const tooltip = new Tooltip(
                id
                    ? document.getElementById(`max-qty-tooltip-${id}`)
                    : maxQtyTooltip
            )
            activeTooltips[tooltipId] = tooltip
            tooltip.show()

            setTimeout(() => {
                tooltip?.dispose()
                activeTooltips[tooltipId] = null
            }, 5000)
        }
    }

    function showBannerQtyTooltip(el) {
        const tooltipId = el.dataset.id
        const tooltipEl = el.parentElement.querySelector('.max-qty-tooltip')
        if (!activeTooltips[tooltipId]) {
            const tooltip = new Tooltip(tooltipEl)
            activeTooltips[tooltipId] = tooltip
            tooltip.show()

            setTimeout(() => {
                tooltip?.dispose()
                activeTooltips[tooltipId] = null
            }, 2000)
        }
    }

    const qtyEvent = new Event('qty-change')
    const qtyEventModal = new Event('qty-rx-warning-modal')

    const qtyFormBtns = document.querySelectorAll('[data-qtyForm-btn]'),
        qtyFormInputs = document.querySelectorAll('[data-qtyForm-input]')

    Array.from(qtyFormBtns).forEach(function (el) {
        el.addEventListener('click', function (ev) {
            const elementId = el.getAttribute('data-id')
            const isRx = el.getAttribute('data-isRx')
            const qtyInput = document.querySelectorAll(
                `input.qty[data-id="${elementId}"]`
            )

            qtyInput.forEach((input) => {
                let qtyMax = input.getAttribute('data-qtyForm-limit'),
                    qtyVal = parseInt(input.value)

                input.setAttribute('data-oldvalue', input.value)

                if (isRx && ev.detail.fromRxQtyWarningModal == undefined) {
                    el.dispatchEvent(qtyEventModal)

                    return
                }

                if (this.getAttribute('data-qtyForm-btn') === 'up') {
                    input.value = ++qtyVal
                } else {
                    input.value = --qtyVal
                }

                if (qtyVal > qtyMax) {
                    input.value = qtyMax
                    if (
                        el.parentElement.classList.contains(
                            'product-qty-slider'
                        )
                    ) {
                        showBannerQtyTooltip(el)
                    } else {
                        showQtyTooltip(el.dataset.id)
                    }
                } else if (qtyVal > 1) {
                    input.value = qtyVal
                } else {
                    input.value = 1
                }

                const buttonMinus = document.querySelector(`button[data-id="${elementId}"][data-qtyform-btn="down"]`)
                if (input.value > 1 ) {
                  buttonMinus.classList.add('active')
                } else {
                  buttonMinus.classList.remove('active')
                }

                input.setAttribute('data-val-qtybybuttons', input.value)

                input.dispatchEvent(qtyEvent)

                if (submit) {
                    el.disabled = true
                    submit.form.submit()
                }
            })
        })
    })

    Array.from(qtyForm).forEach(function (el) {
        const qtyInput = el.querySelector('[data-qtyForm-input]')
        if (qtyInput) {
            qtyInput.addEventListener('change', () => {
                const submit = document.querySelector(
                    '.btn-update[name=update_cart_action]'
                )
                if (submit) {
                    el.readonly = true
                    submit.form.submit()
                }
            })
        }
    })

    Array.from(qtyFormInputs).forEach(function (el) {
        el.addEventListener('input', function (event) {
            const el = event.target
            const max = Number(el.getAttribute('data-qtyForm-limit'))

            if (el.value > max) {
                el.value = max
                if (el.parentElement.classList.contains('product-qty-slider')) {
                    showBannerQtyTooltip(el)
                } else {
                    showQtyTooltip(el.dataset.id)
                }
            }
        })

        el.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault()

                if (
                    el.getAttribute('data-isRx') &&
                    (event.detail == undefined || event.detail == 0)
                ) {
                    dispatchRxWarningModal(el)

                    return
                }

                el.dispatchEvent(qtyEvent)
            }
        })

        el.addEventListener('change', function (event) {
            const el = event.target
            if (el.value === '' || el.value < 1) {
                el.value = 1
            }

            const isRx = el.getAttribute('data-isRx')

            if (el.getAttribute('data-isRx') && event.detail == undefined) {
                dispatchRxWarningModal(el)

                return
            }

            if (
                isRx &&
                event.detail != undefined &&
                event.detail.fromRxQtyChangeWarningModal != undefined
            ) {
                el.value = event.detail.value
                el.removeAttribute('data-val-qtybybuttons')
                el.setAttribute('data-oldvalue', el.value)
            }

            el.dispatchEvent(qtyEvent)
        })
    })

    function dispatchRxWarningModal(el) {
        const newValue = el.value
        el.value =
            el.getAttribute('data-val-qtybybuttons') != undefined
                ? el.getAttribute('data-val-qtybybuttons')
                : el.getAttribute('data-oldvalue')
        el.dispatchEvent(
            new CustomEvent('qty-rx-warning-modal', {
                detail: { rxwarningvalue: newValue }
            })
        )
    }
}
